import videojs from "video.js";
import { checkTouchScreen } from "../../js/helpers/checkTouchScreen.js"

class ListCameras extends videojs.getComponent('Component') {
	constructor(player, options) {
		super(player, options);
		if (videojs.browser.IS_FIREFOX) {
			this.addClass('vjs-multicam__list-cameras_firefox');
		}
		this.addClass('vjs-multicam__list-cameras');
		this.addClass('vjs-hidden');
	}

	opened() {
		return !this.hasClass('vjs-hidden');
	}

	open() {
		this.options_.onOpen();
		setTimeout(() => {
			super.show();
			this.player().trigger('ListCameras/open');
		}, 100);
	}

	close() {
		super.hide();
		this.options_.onClose();
	}
}

videojs.registerComponent('ListCameras', ListCameras);

